<template>
  <div class="row">
    <b-card class="col-12" no-body>
      <b-form @submit="onSubmit" class="row">
        <div class="col-12 d-flex justify-content-center">
          <upload-foto
            @upload="(img) => (pessoa.foto = img)"
            disabled
            :fotoSrc="pessoa.foto"
          />
        </div>
        <input-text
          class="col-12 col-md-4"
          label="Nome"
          disabled
          v-model="pessoa.nome"
        />
        <input-text
          class="col-12 col-md-4"
          label="CPF"
          disabled
          v-model="pessoa.cpf"
        />
        <input-text
          class="col-12 col-md-4"
          label="Email"
          disabled
          v-model="pessoa.email"
        />

        <input-text
          class="col-12"
          label="Username"
          v-model="form.nomeUsuario"
          v-if="ehAdmin"
        />

        <input-checkbox
          id="input-eh-administrador"
          class="col-12 mb-3"
          switch
          text="É administrador?"
          switchSize="lg"
          v-model="ehAdministrador"
        />

        <div class="col-12">
          <b-button
            variant="success"
            type="submit"
            v-if="id && permissao.u && ehAdmin"
          >
            <i class="fa-solid fa-check mr-2"></i>
            Salvar
          </b-button>
        </div>
      </b-form>
    </b-card>

    <accordion
      class="col-12 mt-3"
      id="accordion-permissao"
      title="Permissões"
      accordion="accordion-permissao"
      v-if="id && pessoasPermissoes.r"
    >
      <div class="p-3">
        <b-table-simple bordered sticky-header="600px">
          <b-thead head-variant="dark">
            <b-tr>
              <b-th>Permissão</b-th>

              <b-th class="text-center">Visualizar</b-th>
              <b-th class="text-center">Criar</b-th>
              <b-th class="text-center">Editar</b-th>
              <b-th class="text-center">Excluir</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(permissao, i) in permissoesFiltrada" :key="i">
              <b-td>
                <i
                  class="sub fa-solid fa-arrow-turn-up mr-3"
                  v-if="getEnum(permissao.campo).sub"
                ></i>
                <span>
                  {{ getEnum(permissao.campo).text }}
                </span>
              </b-td>

              <b-td class="text-center">
                <b-form-checkbox
                  @change="selecionarSubs($event, getEnum(permissao.campo))"
                  v-model="permissao.r"
                  :disabled="
                    !getEnum(permissao.campo).permissao.r ||
                    !pessoasPermissoes.u
                  "
                />
              </b-td>
              <b-td class="text-center">
                <b-form-checkbox
                  v-model="permissao.c"
                  :disabled="
                    verificarCheckboxDisabilitado(permissao.campo, 'c')
                  "
                />
              </b-td>
              <b-td class="text-center">
                <b-form-checkbox
                  v-model="permissao.u"
                  :disabled="
                    verificarCheckboxDisabilitado(permissao.campo, 'u')
                  "
                />
              </b-td>
              <b-td class="text-center">
                <b-form-checkbox
                  v-model="permissao.d"
                  :disabled="
                    verificarCheckboxDisabilitado(permissao.campo, 'd')
                  "
                />
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <div class="">
          <b-button
            variant="success"
            v-if="pessoasPermissoes.u"
            @click="salvarPermissoes"
          >
            <i class="fa-solid fa-check mr-2"></i>
            Salvar
          </b-button>
        </div>
      </div>
    </accordion>
  </div>
</template>
<script>
import UploadFoto from "@/components/uploadFoto/UploadFoto";
import InputText from "@/components/inputs/InputText";
// import InputSelectTag from "@/components/inputs/InputSelectTag";
import InputCheckbox from "@/components/inputs/InputCheckbox";
import Accordion from "@/components/card/Accordion.vue";
// import PermissoesService from "@/common/services/permissoes/permissoes.service";
import UsuarioService from "@/common/services/usuario/usuario.service";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import Swal from "sweetalert2";
import helpers from "@/common/utils/helpers";
// import InputCheckbox from '../../components/inputs/InputCheckbox.vue';

export default {
  mixins: [AlertasMixin],
  props: ["id"],
  components: {
    UploadFoto,
    InputText,
    // InputSelectTag,
    InputCheckbox,
    Accordion,
  },
  data: () => ({
    permissoes: [],
    pessoa: {
      foto: null,
      nome: null,
      cpf: null,
      email: null,
    },
    form: {
      nomeUsuario: null,
    },
    perfil: [],
    ehAdministrador: false,
    options: {
      perfil: [],
    },
  }),
  methods: {
    getEnum(enumName) {
      return helpers.getEnum(enumName);
    },

    salvarPermissoes: function () {
      this.confirmar("Deseja salvar novas permissões?").then((confirmado) => {
        if (!confirmado) return;
        this.$store.dispatch(START_LOADING);
        let form = {
          usuarioId: this.id,
          permissoes: this.permissoes,
        };

        UsuarioService.salvarPermissoes(form)
          .then(() => {
            this.alertaSucesso("Permissões salvas com sucesso!");
          })
          .catch(() => {
            this.alertaErro("Erro ao salvar permissões!");
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    buscarPermissoes: function (id) {
      UsuarioService.buscarPermissoes(id).then((response) => {
        var permissoes = response.data.data.filter((el) => {
          var campo = this.getEnum(el.campo);
          if (campo.esconder) return false;
          if (campo.somenteAdmin && !this.ehAdmin) return false;
          return true;
        });

        var indiceTrl = permissoes.findIndex((el) => el.campo === "ProjetosPdTRL");
        if (indiceTrl !== -1) {
          var [trl] = permissoes.splice(indiceTrl, 1);
          var indiceCronogramaEtapa = permissoes.findIndex((el) => el.campo === "ProjetosPdCronogramaEtapa");
          permissoes.splice(indiceCronogramaEtapa + 1, 0, trl);
        }

        this.permissoes = permissoes;
      });
    },

    onSubmit: function (e) {
      e.preventDefault();

      if (!this.form.nomeUsuario) {
        Swal.fire({
          title: "Atenção",
          text: "O campo nome de usuário é obrigatório",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }

      Swal.fire({
        title: "Aviso",
        text: "Deseja salvar as alterações?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Continuar",
        denyButtonText: `Não`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch(START_LOADING);
          UsuarioService.salvar(this.form)
            .then(() => {
              let perfilForm = {
                usuarioId: this.form.id,
                ehAdministrador: this.ehAdministrador,
              };

              UsuarioService.editarPerfis(perfilForm)
                .then(() => {
                  Swal.fire({
                    title: "Sucesso",
                    text: "Usuário atualizado com sucesso",
                    icon: "success",
                  }).then(() => {
                    this.$router.push({ name: "usuarios" });
                  });
                })
                .catch(() => {
                  Swal.fire({
                    title: "Atenção",
                    text: "Ocorreu um erro ao atualizar o usuário",
                    icon: "warning",
                    confirmButtonText: "Ok",
                  });
                })
                .finally(() => {
                  this.$store.dispatch(STOP_LOADING);
                });
            })
            .catch(() => {
              this.$store.dispatch(STOP_LOADING);
              Swal.fire({
                title: "Atenção",
                text: "Ocorreu um erro ao atualizar o usuário",
                icon: "warning",
                confirmButtonText: "Ok",
              });
            });
        }
      });
    },

    fetchUsuario: function () {
      UsuarioService.buscarPorId(this.id).then((response) => {
        this.form.id = response.data.data.id;
        this.form.nomeUsuario = response.data.data.nomeUsuario;

        if (response.data.data.pessoa) this.pessoa = response.data.data.pessoa;

        if (response.data.data.usuarioPerfis[0]?.perfil)
          this.ehAdministrador =
            response.data.data.usuarioPerfis[0].perfil.nome === "admin";
      });
    },

    selecionarSubs: function (checked, objeto) {
      if (!objeto.subEnums) return;

      objeto.subEnums.forEach((sub) => {
        let permissao = this.permissoes.find((el) => el.campo === sub);

        if (!this.verificarPermissao(permissao.campo, "r")) return;

        if (checked) {
          permissao.r = true;
        } else {
          permissao.c = false;
          permissao.r = false;
          permissao.u = false;
          permissao.d = false;
        }
      });
    },
    verificarPermissao: function (campo, permissao) {
      if (this.ehAdmin) return true;
      return this.$store.getters["app/retornaPermissao"](campo)[permissao];
    },
    verificarCheckboxDisabilitado(campo, permissao) {
      return (
        !this.pessoasPermissoes.u ||
        !this.verificarPermissao(campo, permissao) ||
        !this.getEnum(campo).permissao[permissao] ||
        this.getEnum(campo).CUDAdmin ||
        (this.getEnum(campo).tipoUsuarioCUD
          ? this.getEnum(campo).tipoUsuarioCUD != this.form.perfil
          : false)
      );
    },
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [
      { titulo: "Usuários", to: { name: "usuarios" } },
      { titulo: "Editar" },
    ]);

    if (this.id) {
      this.fetchUsuario();
      this.buscarPermissoes(this.id);
    }
  },
  computed: {
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("Usuarios");
    },
    pessoasPermissoes() {
      return this.$store.getters["app/retornaPermissao"]("UsuariosPermissoes");
    },
    minhasPermissoes() {
      return this.$store.state.app.permissao;
    },
    ehAdmin() {
      return this.$store.getters["app/ehAdmin"];
    },
    permissoesFiltrada: function () {
      if (this.ehAdmin) return this.permissoes;

      return this.permissoes.filter((el) => {
        return this.$store.getters["app/retornaPermissao"](el.campo).r;
      });
    },
  },
};
</script>
<style>
.card {
  min-height: inherit !important;
}

.sub {
  color: #a7a7a7;
  -webkit-transform: rotate(-90deg);
  transform: rotate(90deg);
}
</style>